<template>
    <div class="btn-group">
        <button data-toggle="dropdown" class="btn btn-default dropdown-toggle">
            <span>{{getCurrencySymbolFromString(default_currency)}}</span> <span class="button-text">{{default_currency}}</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-right">
            <li v-for="currency in currencyOptions" :key="currency.value">
                <a href="" @click.prevent="selectCurrency(currency.value)">
                    <span>{{currency.symbol}}</span> <span class="button-text">{{currency.value}}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>

    import {Utils} from "../../common/utils";
    import {StorageHelper} from "../../common/storageHelper";
    import {updateDefaultCurrencyUser, updateDefaultCurrencyUserConsumer} from "../../api";
    import {CURRENCY_OPTIONS} from "../../common/constants";

    export default {
        name: "SelectCurrencies",
        data: () => {
            return {
                default_currency: Utils.getDefaultCurrency(),
                currencyOptions: CURRENCY_OPTIONS(),
            }
        },
        methods: {
            getCurrencySymbolFromString(currency) {
                return Utils.getCurrencySymbolFromString(currency);
            },
            async selectCurrency(currency) {
                this.default_currency = currency;
                StorageHelper.setDefaultCurrency(currency);

                let user = StorageHelper.getUser();
                let token = StorageHelper.getToken();
                let userConsumer = StorageHelper.getUserConsumer();
                let tokenConsumer = StorageHelper.getTokenConsumer();

                if (user && token) {
                    try {
                        let userResponse = await updateDefaultCurrencyUser(currency);
                        user.default_currency = userResponse.default_currency;
                        StorageHelper.setUser(user)
                    } catch (e) {
                        console.log(e)
                    }
                }

                if (userConsumer && tokenConsumer) {
                    try {
                        let userConsumerResponse = await updateDefaultCurrencyUserConsumer(currency);
                        userConsumer.default_currency = userConsumerResponse.default_currency;
                        StorageHelper.setUserConsumer(userConsumer)
                    } catch (e) {
                        console.log(e)
                    }
                }

                this.$emit('currency-changed-callback', currency)
            },
        }
    };
</script>
